import { Listing, Service } from "../types";

function serialisePhoneNumber(service: Service) {
  const contacts = service.contacts;

  const phoneType = contacts.find(
    (contact) => contact?.valueType?.label === "Phone"
  );

  return phoneType && phoneType.value;
}

function serialiseWebsite(service: Service) {
  const contacts = service.contacts;

  const phoneType = contacts.find(
    (contact) => contact?.valueType?.label === "Website"
  );

  return phoneType && phoneType.value;
}

function serialiseAddress(service: Service) {
  const location = service.location?.physicalLocation;

  if (!location) {
    return;
  }

  const titleizeSuburb = `${location.suburb.label.charAt(
    0
  )}${location.suburb.label.slice(1).toLowerCase()}`;

  return (
    location && {
      addressLine1: location.addressLine1,
      addressLine2: location.addressLine2,
      addressLine3: location.addressLine3,
      suburb: titleizeSuburb,
      postcode: location.postcode,
      state: location.state.label,
    }
  );
}

function serialiseService(service: Service): Listing {
  return {
    id: service.id,
    displayName:
      service.displayName ||
      service.location?.name ||
      service.organisation?.name,
    phoneNumber: serialisePhoneNumber(service),
    website: serialiseWebsite(service),
    address: serialiseAddress(service),
  };
}
export default serialiseService;
